import { gettext } from '@eventbrite/i18n';
import MamasNightmarket from '../static/images/mamas-nightmarket.svg';
import Seedtalks from '../static/images/Seed-talks.svg';
import SomethingDopeForThePeople from '../static/images/something-dope-for-the-people.svg';

export const TESTIMONIALS = [
    {
        quote: gettext(
            '"For people coming to our event outside of San Francisco, nearly 70% of our attendees say they found it on Eventbrite."',
        ),
        image: MamasNightmarket,
        attribution: gettext('MAMA’s Nightmarket'),
        link: 'https://www.eventbrite.com/blog/mamas-nightmarket-growth-in-ticket-sales-eventbrite/',
    },
    {
        quote: gettext(
            '"The conversion rate on Eventbrite was 20% better than other ticketing platforms...plus the automated emails generate a lot of new sales each time we post a new event."',
        ),
        image: Seedtalks,
        attribution: gettext('Seed Talks'),
        link: 'https://www.eventbrite.co.uk/blog/seed-talks-on-using-eventbrite-tools-to-drive-global-expansion/',
    },
    {
        quote: gettext(
            "\"We rely on Eventbrite for its discoverability and we're gaining followers. I can't think of an event where it wouldn't make sense to be using Eventbrite's marketing tools.\"",
        ),
        image: SomethingDopeForThePeople,
        attribution: gettext('Something Dope for the People'),
        link: 'https://www.eventbrite.com/blog/something-dope-for-the-people/',
    },
];
